<div class="custom-box">
  <sia-text-box
    style="width: 100%"
    [(value)]="value"
    [label]="label()"
    [disabled]="disabled()"
    [status]="status()"
    [statusMessage]="statusMessage()"
    [statusMessages]="statusMessages()"
    [modified]="modified()"
    [id]="id()"
    [tabDisabled]="tabDisabled()"
  ></sia-text-box>
  <sia-google-search-button [urlPattern]="urlPattern()" [guid]="guid()">
  </sia-google-search-button>
</div>
